import styled from '@emotion/styled';
import { ButtonLink } from '@blueprint/ui';
import { zooplaTheme as theme } from '@blueprint/theme';

export const ButtonWrapper = styled(ButtonLink)`
    margin-bottom: ${theme.spacing['24px']};
`;
